@if (text) {
  <p
    class="subscription-pause-notice"
    [class.subscription-pause-notice--scheduled]="pause?.state === 'scheduled'"
    role="status"
  >
    {{ text }}
  </p>
}
